'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosNutritoutline = function IoIosNutritoutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28 18.3c0.4 0.5 0.8 1.1 0.8 1.8 0 0.8-0.4 1.5-1.1 2s-3.9 2.9-8.2 6l-3-2.4c-0.2-0.2-0.3-0.2-0.5-0.2-0.1 0-0.1 0-0.2 0-0.2 0.2-0.2 0.5 0.1 0.8l2.2 2.8-9 6.5c-0.4 0.3-1 0.7-1.6 0.7-1.4 0-2.5-1.1-2.5-2.5 0-0.6 0.1-1.1 0.3-1.5 0.2-0.1 1.3-1.9 2.9-4.4l1.6 1.3c0.2 0.2 0.4 0.2 0.5 0.2 0.1 0 0.3 0 0.3-0.1 0.2-0.2 0.1-0.5-0.1-0.8l-1.5-1.8c2.1-3.3 4.7-7.5 6.6-10.4l2.8 2.3c0.1 0.2 0.3 0.2 0.4 0.2 0.1 0 0.2 0 0.3-0.1 0.1-0.2 0.1-0.4-0.1-0.7l-2.6-3.2c0.9-1.4 1.5-2.2 1.5-2.2 0.5-0.8 1.2-1.3 2.1-1.3 0.7 0 1.4 0.3 1.9 0.8l6.1 6.2z m-1 2.8c0.3-0.2 0.5-0.6 0.5-1 0-0.3-0.2-0.7-0.4-1l-0.4-0.3v-0.1l-5.8-5.7c-0.2-0.3-0.6-0.4-0.9-0.4-0.5 0-0.8 0.2-1 0.6l-0.4 0.6c-0.2 0.3-0.4 0.6-0.6 1l1.9 2.3 0.1 0.1c0.6 0.8 0.6 1.7 0 2.3l-0.2 0.2c-0.3 0.2-0.6 0.4-1 0.4s-0.8-0.2-1.2-0.5v-0.1h-0.1l-1.6-1.4-1.9 3.1-3.5 5.4 1 1.1c0.6 0.8 0.6 1.8 0 2.5-0.3 0.3-0.7 0.4-1.2 0.4-0.4 0-0.9-0.1-1.2-0.4l-0.6-0.4c-0.2 0.4-0.4 0.7-0.6 1-1 1.5-1.3 2-1.4 2.2-0.1 0.3-0.2 0.5-0.2 0.7 0 0.8 0.6 1.3 1.3 1.3 0.2 0 0.4-0.2 0.8-0.4l7.9-5.8-1.4-1.7h-0.1c-0.6-0.8-0.6-1.8 0-2.4 0.4-0.3 0.8-0.5 1.2-0.5s0.9 0.2 1.3 0.5h0l2.2 1.9c3.9-2.9 7.3-5.4 7.5-5.5z m7.4-12.1l0.6 1.1-0.4 0.2-8 4.7-1.4-1.3 5.6-9.6 0.1-0.3 1.1 0.6-0.2 0.3-4.9 8.7 7.1-4.2z' })
        )
    );
};

exports.default = IoIosNutritoutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-nutritoutline.js
// module id = 2253
// module chunks = 0